import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Divider } from 'material-ui';
import { FormattedMessage } from 'react-intl';

import { reverse, map } from 'lodash';

import pallet from 'constants/colors';
import { dateTime } from 'utils/dateTools';
import { getAttendeeMsg } from 'utils/helpers';
import KFlatButton from './KFlatButton';
import KTitle from './KTitle';

const styles = {
  container: {
    maxWidth: 380,
    width: '100%',
    minWidth: 300,
    borderRadius: 8,
    margin: '24px 10px',
    height: 460,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: 36,
    paddingBottom: 24,
  },
  action: {
    minHeight: 40,
    maxHeight: 40,
    justifyContent: 'center',
    flex: '0 1 auto',
    marginLeft: 0,
    marginRight: 0,
  },
  actionButton: {
    fontSize: 14,
    maxWidth: 'none',
    padding: 0,
    whiteSpace: 'nowrap',
    color: pallet.titleColor,
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 18,
  },
  divider: {
  },
  times: {
    marginTop: 'auto',
    marginBottom: 18,
    display: 'flex',
    justifyContent: 'space-between',
  },
  topContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    margin: 0,
    fontSize: 20,
    fontWeight: 600,
    marginTop: 18,
    marginBottom: 18,
  },
  tagContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  attending: {
    alignSelf: 'flex-end',
    backgroundColor: pallet.successColor,
    padding: 6,
    borderRadius: 4,
    color: 'white',
  },
  info: {
    alignSelf: 'flex-end',
    backgroundColor: pallet.infoColor,
    padding: 6,
    borderRadius: 4,
    marginLeft: 4,
    color: 'white',
  },
  urgent: {
    backgroundColor: pallet.warningColor,
    padding: 6,
    borderRadius: 4,
    color: 'white',
    marginLeft: 4,
    whiteSpace: 'nowrap',
  },
  critical: {
    backgroundColor: pallet.errorColor,
    padding: 6,
    borderRadius: 4,
    color: 'white',
    marginLeft: 4,
    whiteSpace: 'nowrap',
  },
  description: {
    color: pallet.subtitleColor,
    overflow: 'hidden',
    maxHeight: 178,
  },
  type: {
    paddingTop: 6,
    paddingBottom: 6,
    paddingRight: 6,
    color: pallet.primary1Color,
  },
};

class KCourse extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      useGroup,
      CourseName,
      CourseGroupName,
      CourseTypeName,
      CourseBegda,
      CourseHours,
      CourseDescriptionHtml,
      attending,
      actions,
      Gender,
      EmployeeMasterID,
      entity: { CoursePoints, CourseAttendees, CourseRequiresApproval },
    } = this.props;

    const thisWeek = new Date();
    thisWeek.setDate(thisWeek.getDate() + 5);
    const tomorrow = new Date();
    tomorrow.setHours(23, 59, 59);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const today = new Date();
    today.setHours(23, 59, 59);
    const now = new Date();
    const startTime = new Date(CourseBegda.entityValue).getTime();
    const showToday = startTime < today && startTime > now.getTime();
    const showStarted = startTime < today && startTime < now.getTime() && !showToday;
    const showTomorrow = startTime < tomorrow.getTime() && !showStarted && !showToday;
    const showThisWeek = startTime < thisWeek.getTime() && !showStarted && !showTomorrow && !showToday;

    const attendeeMsg = getAttendeeMsg(CourseAttendees, EmployeeMasterID, Gender);

    return (
      <Paper style={styles.container} zDepth={0}>
        <div style={styles.topContainer}>
          {useGroup ?
            <div style={styles.type}>{CourseGroupName.value || '-'}</div> :
            <div style={styles.type}>{CourseTypeName.value || '-'}</div>
          }
          <div style={styles.tagContainer}>
            {CourseRequiresApproval && !attending && <div style={styles.info}><FormattedMessage id="course.requiresApproval" /></div>}
            {attending && <div style={styles.attending}>{attendeeMsg}</div>}
            {showToday && <div style={styles.urgent}><FormattedMessage id="course.today" /></div>}
            {showStarted && <div style={styles.critical}><FormattedMessage id="course.started" /></div>}
            {showTomorrow && <div style={styles.urgent}><FormattedMessage id="course.tomorrow" /></div>}
            {showThisWeek && <div style={styles.urgent}><FormattedMessage id="course.soon" /></div>}
            {CoursePoints ? <div style={styles.info}>{CoursePoints}</div> : null}
          </div>
        </div>
        <KTitle
          style={styles.title}
          title={CourseName.value}
        />
        {CourseDescriptionHtml.value ?
          <div style={styles.description} dangerouslySetInnerHTML={{ __html: CourseDescriptionHtml.value }} /> :
          <div style={styles.description}><FormattedMessage id="course.noDescription" /></div>
        }
        <div style={styles.times}>
          <div style={styles.dateTime}>{dateTime(CourseBegda.entityValue)}</div>
          <div style={styles.length}>{CourseHours.value}</div>
        </div>
        <Divider style={styles.divider} />
        <div style={styles.actionContainer}>
          {map(reverse(actions), (a, i) => {
            const style = { ...styles.actionButton };
            if (a.primary) {
              style.color = pallet.primary1Color;
            } else if (a.secondary) {
              style.color = pallet.errorColor;
            }
            return (
              <KFlatButton
                key={i}
                containerStyle={styles.action}
                style={style}
                onClick={a.action}
                label={a.label}
                disabled={a.disabled}
              />
            );
          })}
        </div>
      </Paper>
    );
  }
}

KCourse.propTypes = {
  attending: PropTypes.bool,
  CourseName: PropTypes.object,
  CourseHours: PropTypes.object,
  useGroup: PropTypes.bool,
  CourseBegda: PropTypes.object,
  entity: PropTypes.shape({
    CoursePoints: PropTypes.number,
    CourseAttendees: PropTypes.arrayOf(PropTypes.shape({})),
    CourseRequiresApproval: PropTypes.bool,
  }),
  CourseGroupName: PropTypes.object,
  CourseTypeName: PropTypes.object,
  CourseDescriptionHtml: PropTypes.object,
  actions: PropTypes.array,
  Gender: PropTypes.string.isRequired,
  EmployeeMasterID: PropTypes.number.isRequired,
};

export default KCourse;



// WEBPACK FOOTER //
// ./src/components/KJRN/KCourse.js